import PointOfSaleOutlinedIcon from '@mui/icons-material/PointOfSaleOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import type { CurrentUser } from '../../api/types/auth';
import { isFeatureEnabled } from '../../config/featureFlags';
import PosReportPage from './pages/PosReportPage';
import PosTransactionPage from './pages/PosTransactionPage';

/** Migration guide Bölüm 5.3 "Pos": visible when IsVirtualPosEnabled is on, EXCEPT
 *  for CORPORATE-type GSAs. */
const isVisible = (user: CurrentUser | null) =>
  isFeatureEnabled('IsVirtualPosEnabled') && user?.gsaType !== 'CORPORATE';

export const posModule: ModuleDefinition = {
  routes: [
    { path: 'pos', element: <PosTransactionPage /> },
    { path: 'pos/report', element: <PosReportPage /> },
  ],
  menuItems: [
    {
      label: 'Pos Çekim',
      path: 'pos',
      icon: <PointOfSaleOutlinedIcon />,
      group: 'Pos',
      groupIcon: <PointOfSaleOutlinedIcon />,
      isVisible,
    },
    {
      label: 'Pos İşlem Raporları',
      path: 'pos/report',
      icon: <ReceiptLongOutlinedIcon />,
      group: 'Pos',
      isVisible,
    },
  ],
};
